import type React from "react"
import { useState } from "react"
import "./form-ui.css"
import SearchIcon from "../../assets/svgs/SearchIcon"

const SearchFilterInput = ({ placeholder, searchTerm, handleSearch, extraClass = '' }) => {
  return (
    <form
      className={`search-form ${extraClass}`}
      // Pressing Enter inside a text <input> submits its enclosing <form> by default -- with no action/
      // onSubmit handler of its own, the browser's default submit behavior reloads the current page, wiping
      // all in-memory state (every list this component filters, not just Email). Filtering already happens
      // live on every keystroke via handleSearch/onChange, so Enter has nothing useful left to do here.
      onSubmit={(e) => e.preventDefault()}
    >
      <div className="search-input-container">
        <SearchIcon />
        <input
          type="text"
          className="search-input"
          placeholder={placeholder}
          value={searchTerm || ''}
          onChange={handleSearch}
        />
      </div>
    </form>
  );
};

export default SearchFilterInput;
